// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useEffect, useMemo, useState} from 'react';
import {Link} from 'react-router-dom';
import cn from 'classnames';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {use_pathname} from '../../../../hola/pub/lib/use_pathname';
import {Overview} from '../../ui/dashboard/overview';
import {My_plans} from '../../ui/dashboard/my_plans';
import {App_context} from 'hola_app_context';
import {My_account} from '../../ui/dashboard/my_account';
import {Sidebar, Topbar} from '../../ui/dashboard/main_menu/main_menu';
import {Notifications} from '../../ui/dashboard/notifications';
import {useHistory} from 'react-router';
import {use_login} from '../../ui/navbar/use_login';
import {Thank_you_modal} from '../../ui/dashboard/thank_you_modal';
import {get_payment_renew_url, total_orders_count}
    from '../../ui/dashboard/utils';
import {Navbar_portal, NAVBAR_SLOTS} from '../../ui/navbar/use_navbar';
import Icon_notification from '../../img/icons/24/notification.svg';
import Icon_alert from '../../img/icons/alert.svg';
import Icon_alert_error from '../../img/icons/alert_error.svg';
import {Button} from '../../../../hola/pub/lib/button';
import {Splash_screen_loader}
    from '../../ui/splash_screen_loader/splash_screen_loader';
import {use_qs_with_set} from '../../../../hola/pub/lib/use_qs';
// @ts-ignore
import cookie from 'cookie';
import {perr} from 'hola_pub_util';
import etask from 'zetask';
import {Pricing_plans} from '../../ui/dashboard/pricing_plans';
import styles from './dashboard.module.less';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import {Dashboard_alerts, Expiring_dialog_alert}
    from '../../ui/dashboard/alert/alert';
import {use_app_context} from '../../lib/app_context';
import {Kyc_modal} from '../../ui/dashboard/kyc/kyc';
import {Support_form} from '../../ui/dashboard/support_form';
import {Modal} from '../../../../hola/pub/lib/modal';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {use_screen} from '../../../../hola/pub/lib/screen_util';
import Icon_check from '../../img/icons/check_thin.svg';
import storage from '/util/storage.js';
import {i_notification, i_notification_alert}
    from '../../ui/dashboard/utils/notifications';
import {Alert_notification}
    from '../../../../oculus/pub/pages/oculus.toolip.io/alert_notification';
import {use_notifications_ws} from '../../lib/use_notifications_ws';
import {Notification_toast} from '../../../../oculus/pub/ui/dashboard/notification_toast';

const Update_cc_success = ({is_visible}: {is_visible: boolean})=>{
    const {theme} = useContext(Settings_context);
    const {width} = use_screen();
    const {set_qs} = use_qs_with_set();
    const sidebar: HTMLDivElement =
        document.querySelector('[class*="sidebar"]');
    const left = (width + sidebar?.offsetWidth) / 2;
    setTimeout(()=>{
        if (!is_visible)
            return;
        storage.clr('renew_update_cc_orig');
        const el = document.querySelector('[class^="update_cc_success"]');
        el.classList.add(styles.visible);
        setTimeout(()=>{
            set_qs({update_payment_method: ''});
            el.classList.remove(styles.visible);
        }, 10000);
    }, 500);
    return <div className={styles.update_cc_success}
      style={{left: `${left}px`}}>
      <div className={styles.icon_check_wrapper}><Icon_check /></div>
      <div className={styles.text_container}>
        <p className={cn(theme.p14, theme.color_n700, theme.med)}>
          Payment Method Updated
        </p>
        <p className={cn(theme.p12, theme.color_n500)}>
          You've successfully updated your payment details.
        </p>
      </div>
    </div>;
};

export const Root = ()=>{
    const {params} = use_pathname();
    const {user, is_client} = useContext(App_context);
    const {t} = use_translation_v({no_defaults: true});
    const [unread_count, set_unread_count] = useState(0);
    const [alert_notification, set_alert_notification] =
        useState<i_notification_alert[]>([]);
    const [loading, set_loading] = useState(true);
    const [only_unread_notification_ids, set_only_unread_notification_ids] =
        useState<string[]>([]);
     const [latest_toast, set_latest_toast] =
            useState<i_notification | null>(null);
    const [notifications, set_notifications] = useState<i_notification[]>([]);
    const {
        dashboard, renew_error_expired_in_day,
        renew_error_orders, renew_error_expired_in_two_days
    } = use_app_context();
    const {info, dispatch} = dashboard;
    const [show_payment_err, set_show_payment_err] = useState(false);
    const {qs, set_qs} = use_qs_with_set();
    const {show_login_form} = use_login(true, '/dashboard');
    const history = useHistory();
    const hide_menu_items = useMemo(()=>{
        if (total_orders_count(info.orders)==0)
            return new Set(['overview']);
        return new Set<string>();
    }, [info.orders]);
    const handle_remove = (notification_id: string)=>{
        etask(function*(){
              try {
                yield fetch(`/api/remove_notifications_item/${notification_id}`, {
                  method: 'DELETE',
                });
                set_notifications(prev=>prev
                    .filter(n=>n._id !== notification_id));
                set_alert_notification(prev=>
                    prev.filter(n=>n._id !== notification_id));
            } catch(e){
                console.error('Failed to remove notification:', e);
            }
        });
    };
    const fetch_notifs_data = ()=>etask(function*(){
        const res =
            yield fetch('/api/get_account_notifications');
        const only_alert = res
            ?.filter(n=>n.type === 'alert');
        const only_notifications = res
            ?.filter(n=>n.type === 'notification');
        const normalized = only_notifications.map(n=>({
            ...n,
            open_in_new_tab: n.open_in_new_tab === true ||
                n.open_in_new_tab === 'true',
            read: n.read === true || n.read === 'true',
        }));
        const sorted = normalized.sort((a, b)=>
            new Date(b.time).getTime() - new Date(a.time).getTime());
        const unread_notification_ids = normalized
            .filter(normalized_n=>!normalized_n.read)
            .map(unread_n=>unread_n._id);
        set_only_unread_notification_ids(unread_notification_ids);
        set_notifications(sorted);
        set_alert_notification(only_alert);
        set_unread_count(normalized.filter(n=>!n.read).length);
        set_loading(false);
        return res;
    });
    use_notifications_ws({
        user_id: user?.hola_uid,
        on_notification: notif=>{
            if (notif._id)
                fetch_notifs_data();
            const normalized = {
                ...notif,
                read: notif.read == true,
                open_in_new_tab:
                    (notif.open_in_new_tab as string | boolean) === true ||
                    (notif.open_in_new_tab as string | boolean) === 'true',
            };
            if (notif.type === 'notification')
                set_latest_toast(normalized);
        },
    });
    useEffect(()=>{
        if (renew_error_expired_in_two_days)
            set_show_payment_err(true);
    }, [info?.inited]);
    useEffect(()=>{
        if (user)
            fetch_notifs_data();
    }, [user, params.page]);
    useEffect(()=>{
        if (params.page === 'notifications' && latest_toast)
            set_latest_toast(null);
        if (params.page !== 'account' && params.section)
            history.replace(`/dashboard/page/${params.page}`);
    }, [params.page, latest_toast]);
    useEffect(()=>{
        if (user)
        {
            dispatch({type: 'refresh_orders'});
            try {
                (window as any).dataLayer.push({
                    event: 'gtag.logged_in_user_visit_dashboard',
                });
            } catch(e){}
        }
        perr({id: 'toolip_dashboard_visit'});
    }, []);
    useEffect(()=>{
        const after_signup = qs.signup_success || qs.signup_failed;
        if (!user && after_signup)
        {
            etask(function*(){
                const signup_token = cookie.get('signup_token');
                if (signup_token)
                {
                    yield perr({id: 'toolip_signup_after_purchase_manual'});
                    location.href = '/users/confirm_signup_token?token='+
                        signup_token + '&username=' + qs.email;
                }
                perr({id: 'toolip_signup_after_purchase_issue'});
            });
        }
        else if (user && after_signup)
            perr({id: 'toolip_signup_after_purchase_success'});
    }, []);
    const support_form_close = ()=>set_qs({support_form: ''});
    const is_update_cc_path = Object.keys(params).length == 1 &&
        (params.page == 'account' || params.page == 'plans') ? true :
        params.page == 'account' && params.token ? true : false;
    const show_update_cc_toast = qs.update_payment_method == 'success' &&
        is_update_cc_path && info.inited;
    return <div className={styles.root}>
      <Update_cc_success is_visible={show_update_cc_toast} />
      {is_client && <Navbar_portal
        slot={NAVBAR_SLOTS.mobile_right}>
        <div className={styles.add_more_navbar}>
          {unread_count > 0 ? <div className={styles.icon_badge_block}>
            <span className={cn(styles.icon_badge,
            unread_count > 99 && styles.unread_badge_sm)}>{unread_count}</span>
            <Link to="/dashboard/page/notifications">
            <Icon_notification/>
          </Link></div> : <Link to="/dashboard/page/notifications">
            <Icon_notification/>
          </Link>}
          <Button caption={t('Add proxies')}
            color={'black'} round={false}
            size={'sm'} to={'/pricing'}/>
        </div>
      </Navbar_portal>}
      <Thank_you_modal/>
      <Kyc_modal site='toolip' />
      <Modal lighter_close_btn low_dim paddingless width={640}
        is_open={user && !!qs?.support_form}
        on_close={support_form_close} on_overlay_click={support_form_close}
        cls={styles.support_req_modal}
        content_cls={styles.support_modal_content}>
        <Support_form on_close={support_form_close} orders={info.orders} />
      </Modal>
      <Splash_screen_loader show={!info.inited}/>
      <div className={styles.layout}>
        <Topbar hide_items={hide_menu_items}/>
        <Sidebar hide_items={hide_menu_items} unread_count={unread_count}/>
        <div className={styles.panel}>
            {latest_toast && <div className={styles.toast_wrapper}>
            <Notification_toast
              title={latest_toast.title}
              message={latest_toast.message}
              button_text={latest_toast.button_text}
              button_link={latest_toast.button_link}
              icon_url={latest_toast.icon_url}
              variant={latest_toast.variant}
              on_delete={()=>set_latest_toast(null)}
              open_in_new_tab={latest_toast.open_in_new_tab}
              site='toolip'
            />
          </div>}
          {alert_notification.length > 0 &&
            <Alert_notification
              key={alert_notification[0]._id}
              message={alert_notification[0].message}
              button_link={alert_notification[0].button_link}
              button_text={alert_notification[0].button_text}
              variant={alert_notification[0].variant}
              open_in_new_tab={alert_notification[0].open_in_new_tab}
              handle_remove={()=>handle_remove(alert_notification[0]._id)}
              toolip/>}
          <Dashboard_alerts
            icon_warn={<Icon_alert/>} icon_error={<Icon_alert_error />} />
          <Expiring_dialog_alert
            is_open={show_payment_err}
            close={()=>set_show_payment_err(false)}
            on_confirm={()=>{
              set_show_payment_err(false);
              if (!renew_error_orders.length)
                return;
              history.push(get_payment_renew_url(renew_error_orders[0]));
            }}
            renew_error_expired_in_day={renew_error_expired_in_day}
          />
          <div className={styles.panel_wrapper}>
            {(params.page=='overview' || !params.page) && <Overview/>}
            {params.page=='plans' && <My_plans
              countries={info.countries}
              need_login={()=>show_login_form('signup_buttons')}/>}
            {params.page=='pricing' && <Pricing_plans/>}
            {params.page=='account' && <My_account
              auth={(state = 'signup')=>show_login_form(`${state}_buttons`)}/>}
            {params.page=='notifications' && <Notifications
              notifications={notifications} loading={loading}
              only_unread_notification_ids={only_unread_notification_ids}
              handle_remove={handle_remove}
              auth={(state = 'signup')=>show_login_form(`${state}_buttons`)}/>}
          </div>
        </div>
      </div>
    </div>;
};

const meta = {
    meta: props=>{
        const {translate = t=>t} = props;
        const page = props?.params?.page;
        let canonical_path = '/dashboard';
        if (page && page !== 'overview')
            canonical_path = `/dashboard/page/${page}`;
        return {
            title: translate('Dashboard'),
            description: translate('Learn about dashboard and how it can help '
                +'you.'),
            canonical_url: `https://toolip.io${canonical_path}`,
            robots: 'noindex',
        };
    },
    ssr_force: false,
    no_ssr: true,
    footless: true,
    nav_opt: {login_pos: 'burger'},
    translation: {
        enabled: true,
        detect_by_country: true,
        white_list: ['en', 'ru', 'es', 'tr', 'de', 'fr', 'ja', 'he', 'zh']
    },
};

Root.meta = meta;
